import request from '@/utils/request'

export function activityInfoApi(customerKey) {
  return request({
    url: `api/activity/activityInfo/${customerKey}`,
    method: 'get'
  })
}

export function appLoginApi(data) {
  return request({
    url: 'api/auth/bLogin',
    method: 'post',
		data
  })
}

export function queryCodeApi(code) {
  return request({
    url: `api/activity/queryCode/${code}`,
    method: 'get'
  })
}

export function getOssTokenApi () {
  return request({
    url: `/api/commonFile/getOssToken`,
    method: 'get'
  })
}

export function awardOrderApi(data) {
  return request({
    url: 'api/activityOrder/awardOrder',
    method: 'post',
		data
  })
}
